import { dateSorter, dateRenderer, numericSorter, getProp, priceWithCurrencyRenderer } from '@/lib/generic.utils'
import { formatPrice } from '@/lib/formatting.utils'
import AgGridToggle from '@components/ag-grid-helpers/AgGridToggle'

export const subscriptionStatusColumn = () => {
  // fn because in future usage we can add flexibility
  return {
    headerName: 'Status',
    field: 'status.name',
    sortable: false,
    width: 100,
    cellRenderer: params => params.value.slice(0, 1).toUpperCase(),
    tooltipValueGetter: params => params.value,
    cellClassRules: {
      accepted: params => params.value === 'accepted',
      pending: params => params.value === 'pending',
      cancelled: params => params.value === 'cancelled'
    }
  }
}

export const simpleDateCol = props => {
  const base = field => ({
    editable: true,
    comparator: dateSorter,
    valueGetter: params => dateRenderer(params.data[field]),
    cellRenderer: params => dateRenderer(params.data[field]),
    tooltipValueGetter: params => dateRenderer(params.data[field]),
    ...props
  })

  return {
    startDate: {
      headerName: 'Start date',
      field: 'start_date',
      ...base('start_date')
    },
    endDate: {
      headerName: 'End date',
      field: 'end_date',
      ...base('end_date')
    }
  }
}

export const dateColumn = (properties = {}) => {
  return {
    maxWidth: 200,
    floatingFilterComponent: 'AgGridTextDateFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      debounceMs: 1500
    },
    suppressMenu: true,
    filterParams: {
      newRowsAction: 'keep'
    },
    comparator: dateSorter,
    cellRenderer: params => dateRenderer(params.value),
    tooltipValueGetter: params => dateRenderer(params.value),
    ...properties
  }
}

export const renderEndDate = (params, field = 'end_date') => {
  if (!params.data) return
  if (params.data.one_time_purchase) return 'One time purchase'
  return dateRenderer(params.data[field])
}

export const priceColumn = (field, properties = {}) => ({
  field,
  headerClass: 'price-column',
  cellStyle: { textAlign: 'right', paddingRight: '15px !important' },
  filter: 'agNumberColumnFilter',
  floatingFilterComponent: 'AgGridPriceFilter',
  filterParams: {
    fieldId: field.includes('.') ? field.split('.')[1] : field
  },
  comparator: (a, b, nodeA, nodeB) => {
    return numericSorter(nodeA.data[field], nodeB.data[field])
  },
  ...properties
})

export function planWorkflowCol(field, properties = {}) {
  return {
    cellRendererParams: params => {
      if (!params.data) return
      return this.cellParams(params, field)
    },
    cellRendererFramework: AgGridToggle,
    valueGetter: params => {
      if (!params.data) return
      const rowId = params.data.id
      const tasks = this.tasks.get(rowId) || params.data.task_applicability
      const cellData = tasks.find(t => t.name === field)
      return cellData.value
    },
    headerClass: 'task-header-cell',
    minWidth: 65,
    maxWidth: 90,
    ...properties
  }
}

export const financialPeriodColumn = (properties = {}) => ({
  headerName: 'Financial Period',
  field: 'financial_period',
  cellRenderer: params => getProp(params.data.financial_period, 'abbreviation'),
  valueGetter: params => getProp(params.data.financial_period, 'abbreviation'),
  tooltipValueGetter: params => getProp(params.data.financial_period, 'abbreviation'),
  maxWidth: 200,
  ...properties
})

export const priceWithCurrencyColumn = (field, currencyField, properties = {}) => ({
  field,
  headerClass: 'price-column',
  cellStyle: { textAlign: 'right', paddingRight: '15px !important' },
  filter: 'agNumberColumnFilter',
  floatingFilterComponent: 'AgGridPriceFilter',
  filterParams: {
    fieldId: field
  },
  comparator: (a, b, nodeA, nodeB) => numericSorter(nodeA.data[field], nodeB.data[field]),
  cellRenderer: params => {
    params.value = params.data[field]
    return priceWithCurrencyRenderer(params, currencyField)
  },
  tooltipValueGetter: params => {
    params.value = params.data[field]
    return priceWithCurrencyRenderer(params, currencyField, true)
  },
  valueGetter: params => formatPrice(params.data[field]) || '',
  ...properties
})
